import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { startWith } from 'rxjs/operators';
import { User } from 'src/app/models/user';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'filtro-mappa',
  templateUrl: './filtro-mappa.component.html',
  styleUrls: ['./filtro-mappa.component.scss']
})
export class FiltroMappaComponent implements OnInit{
  form: FormGroup;

  @Output() resultingSearch = new EventEmitter<any>();

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      comune: []
    });

    this.form.valueChanges.pipe(startWith(this.form.value)).subscribe(v => this.resultingSearch.emit(v));
  }
}
